import { render, staticRenderFns } from "./comp_Footer-Certificates.vue?vue&type=template&id=6178c81d&scoped=true&"
import script from "./comp_Footer-Certificates.vue?vue&type=script&lang=js&"
export * from "./comp_Footer-Certificates.vue?vue&type=script&lang=js&"
import style0 from "./comp_Footer-Certificates.vue?vue&type=style&index=0&id=6178c81d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6178c81d",
  null
  
)

export default component.exports